<div appearance="warning" size="m" tuiNotification>
  <div>
    <div class="font-bold">
      {{ title }}
    </div>
    <div>
      {{ description }}
    </div>
  </div>
</div>
